"use client";

import { useRef } from "react";
import Image from "next/image";
import HistoryGallerySlider from "@/components/page/LichSu/HistoryGallerySlider";
import type { HistoryGalleryItem } from "@/components/page/LichSu/types";
import "@/styles/page/lich-su/_history-gallery.scss";

interface HistoryGallerySectionProps {
  items: HistoryGalleryItem[];
  title?: string;
  titleId?: string;
  description?: string;
  subtitle?: string;
}

export default function HistoryGallerySection({
  items,
  title = "Góc truyền thống",
  titleId = "goc-truyen-thong-title",
  description = "Đại học Ngân hàng có lịch sử hình thành và phát triển lâu đời, với nhiều truyền thống quý báu được gìn giữ và phát huy qua nhiều thế hệ.",
  subtitle = "Lịch sử hình thành",
}: HistoryGallerySectionProps) {
  const navSlotRef = useRef<HTMLDivElement>(null);

  return (
    <section
      className="history-gallery history-gallery--goc-truyen-thong"
      aria-labelledby={titleId}
    >
      <div className="container">
        <div className="history-gallery__header row">
          <div className="col-12 col-xl-6">
            <div className="history-gallery__header-inner">
              <h2 id={titleId} className="history-gallery__main-title">
                {title}
              </h2>
              <div
                ref={navSlotRef}
                className="history-gallery__header-nav-slot"
                aria-hidden="true"
              />
            </div>
          </div>
          <div className="col-12 col-xl-6">
            <p className="history-gallery__header-desc">{description}</p>
          </div>
        </div>
      </div>

      <div className="container px-0">
        <h3 className="history-gallery__title d-none d-sm-block">{subtitle}</h3>

        <div className="mobile-title-box mobile-title-box--sm mobile-title-box--primary-title d-sm-none container mb-4">
          <div className="mobile-title-box__icon">
            <Image
              src="/assets/images/history_icon.png"
              alt=""
              aria-hidden="true"
              width={40}
              height={40}
            />
          </div>
          <div className="mobile-title-box__content">
            <h2 className="mobile-title-box__title">{subtitle}</h2>
          </div>
        </div>

        <HistoryGallerySlider items={items} navSlotRef={navSlotRef} />
      </div>
    </section>
  );
}

